import React, { useRef } from 'react';
import { Form } from 'react-bootstrap';
import { useFormContext, Controller } from 'react-hook-form';
import FieldError from '../../../../shared/fields-errors/field-error';
import useUploadFile from '../../../../hooks/upload-file.hook';
import UploadImage from '../../../../shared/upload-image/upload-image';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function ProgramInfo(props) {
    const { register, control, formState: { errors }, setValue, watch } = useFormContext();
    const colorControl = register("primary_color");
    const secondaryColorControl = register("secondary_color");
    const setColor = (event) => {
        document.getElementById('txtColor').value = event.target.value;
    }

    const setSecondaryColor = (event) => {
    document.getElementById("txtSecondaryColor").value =
        event.target.value;
};

    return (
        <>
            <div className='main-form-wrapper'>
                <h6 className="mb-3 text-black fw-bold">
                    <i className="fa-solid fa-layer-group text-primary me-2"></i>
                    Basics
                </h6>

                {/* Title and Subtitle Row */}
                <div className='row mb-3'>
                    <div className='col-xxl-6 col-md-12'>
                        <Form.Group>
                            <Form.Label className='text-bold text-black'>
                                <span className='text-danger'>*</span> Title
                            </Form.Label>
                            <Form.Control
                            maxLength={150}
                                {...register("title", {
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                })}
                                type="text" placeholder="Enter title" />
                            {errors?.title ? <FieldError message={errors?.title?.message} /> : ''}
                        </Form.Group>

                    </div>
                    <div className='col-xxl-6 col-md-12'>
                        <Form.Group>
                            <Form.Label className='text-bold text-black'>Subtitle</Form.Label>
                            <Form.Control
                                {...register("subtitle")}
                                type="text" placeholder="Enter subtitle" />
                        </Form.Group>
                    </div>
                </div>

                {/* Description Row */}
                <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <Form.Group>
                            <Form.Label className='text-bold text-black'>Description</Form.Label>
                            <Controller
                                name="program_description"
                                control={control}
                                render={({ field }) => (
                                    <ReactQuill
                                        theme="snow"
                                        value={field.value || ''}
                                        onChange={field.onChange}
                                        modules={{
                                            toolbar: [
                                                [{ header: [1, 2, 3, false] }],
                                                ['bold', 'italic', 'underline', 'strike'],
                                                [{ list: 'ordered' }, { list: 'bullet' }],
                                                [{ color: [] }, { background: [] }],
                                                ['link', 'clean']
                                            ]
                                        }}
                                        placeholder="Enter description"
                                    />
                                )}
                            />
                        </Form.Group>
                    </div>
                </div>

                {/* Banner Image and Location Row Start*/}
                <div className='row'>
                    <>
                        <UploadImage setImage={(imagePath) => {
                            setValue("banner_image_url", imagePath);
                        }} />
                        <input type='hidden' {...register("banner_image_url")} />
                    </>
                    <div className='col-xxl-6 col-md-12'>
                        <Form.Group>
                            <Form.Label className='text-bold text-black'>Location</Form.Label>
                            <Form.Control
                                {...register("program_location")}
                                type="text"
                                placeholder="Enter location"

                            />
                        </Form.Group>
                        <div className="form-group mt-3"><Form.Label className="text-black text-bold" >
                            Primary Color
                            <p className='f-14 mb-0 text-secondary'>Pick a color or change the hexadecimal code</p>
                        </Form.Label>

                            <div className='d-flex justify-content-start align-items-center'>
                                <div className='w-20 me-2'>
                                   <Form.Control
                                     type="color"
                                     {...colorControl}
                                     value={watch("primary_color") || "#0000"}
                                     onChange={(e) => {
                                         colorControl.onChange(e);
                                         setValue("primary_color", e.target.value);
                                     }}
                                     className="form-control w-100"
                                     style={{ height: "2.5rem" }}
                                 />
                                </div>

                                <div className='w-80 '>
                                   <Form.Control
                                       id="txtColor"
                                       {...register("primary_color")}
                                       defaultValue={watch("primary_color")}
                                       onChange={(e) => setValue("primary_color", e.target.value)}
                                       placeholder="Primary Color"
                                       type="text"
                                       className="form-control-alternative form-control"
                                   /></div>
                            </div>
                        </div>
                      
                          <div className="d-flex align-items-center mt-3 mb-2">
                                <input
                                    id="is_secondary_color"
                                    type="checkbox"
                                    {...register("is_secondary_color")}
                                    className="me-2"
                                />

                                <Form.Label
                                    htmlFor="is_secondary_color"
                                    className="mb-0 text-black text-bold"
                                    style={{ cursor: "pointer" }}
                                >
                                    Secondary Color
                                </Form.Label>
                            </div>

                              {watch("is_secondary_color") && (
                            <div className="form-group">
                                <Form.Label className="form-control-label text-black text-bold">
                                    Secondary Color
                                    <p className="f-14 mb-0 text-secondary">
                                        Pick a color or change the hexadecimal code
                                    </p>
                                </Form.Label>

                                <div className="d-flex justify-content-start align-items-center">
                                    <div className="w-20 me-2">
                                        <Form.Control
                                            type="color"
                                          {...secondaryColorControl}
                                            value={watch("secondary_color") || "#0000"}
                                           onChange={(e) => {
                                         secondaryColorControl.onChange(e);
                                         setValue("secondary_color", e.target.value);
                                         }}
                                     className="form-control w-100"
                                     style={{ height: "2.5rem" }}
                                        />
                                    </div>

                                    <div className="w-80">
                                      <Form.Control
                                      id="txtSecondaryColor"
                                      {...register("secondary_color")}
                                      defaultValue={watch("secondary_color")}
                                      onChange={(e) => setValue("secondary_color", e.target.value)}
                                      placeholder="Secondary Color"
                                      type="text"
                                      className="form-control-alternative form-control"
                                       />
                                    </div>
                                </div>
                            </div>
                             )}

                        
                    </div>
                </div>
                {/* Banner Image and Location Row End*/}
            </div>
        </>
    );
}

export default ProgramInfo;